var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyWidgets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04304 0H38.957H40V1.04304V23.5864V24.6295H38.957H1.04304H0V23.5864V1.04304V0H1.04304ZM37.9139 2.08607H2.08603V22.5434H37.9139V2.08607Z",
    fill: "#3BBEE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.925 23.6193L21.0118 23.54C23.6218 28.2762 22.3776 28.4538 27.5 28.4538V30.2792H12.4805V28.4538C17.578 28.4538 16.3317 28.3253 18.925 23.6193Z",
    fill: "#3BBEE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6044 19.8378H5.39108H4.55664V19.0034V4.79004H6.22553V18.1689H19.6044V19.8378Z",
    fill: "#3BBEE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80273 18.1863L7.18208 14.0225L7.56735 13.3482L8.26748 13.6867L10.8818 14.9507L11.0614 11.6057L11.0876 11.1178L11.521 10.9016L15.2102 9.06204L17.3835 5.29785L18.8241 6.12572L16.5224 10.1126L16.1735 10.4451L12.6975 12.1784L12.477 16.2871L12.4098 17.5387L11.284 16.9944L8.24401 15.5246L6.24993 19.0142L4.80273 18.1863Z",
    fill: "#3BBEE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4225 4.99707H32.6484V19.8377H35.4225V4.99707Z",
    fill: "#3BBEE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4401 8.02539H27.666V19.8361H30.4401V8.02539Z",
    fill: "#3BBEE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4616 11.9824H22.6875V19.8356H25.4616V11.9824Z",
    fill: "#3BBEE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyWidgets);
export default __webpack_public_path__ + "static/media/survey-widgets.e32043940640d14bed8d1e1346554620.svg";
export { ForwardRef as ReactComponent };